<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-row>
        <el-form-item label="类型名称" style="margin-right:15px">
          <el-input v-model="form.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="系统类型" style="margin-right:15px">
          <el-input v-model="form.sysType" :disabled="true" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'

export default {
  name: 'CostTypeDetail',
  data() {
    return {
      emptyForm: {},
      dictData: [],
      form: {
        code: '',
        name: '',
        sysType: ''
      }
    }
  },
  created() {
  },
  methods: {
    // 翻译系统类型
    formatterSysType(cellValue) {
      const sd = this.dictData.find(i => i.code === cellValue)
      return sd ? sd.name : ''
    },
    // 获取页面信息
    getInfo(code) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({ url: `/ntocc-basic-api/costType/${code}`, method: 'get' }).then(response => {
        this.form = response.data
        this.form.sysType = this.formatterSysType(this.form.sysType)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin-top: 50px;
  }
</style>
